/**
 * @generated SignedSource<<44a8ce3d8d8970afd3a3222395449724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateIdleTimeInput = {
  id: string;
  name?: string | null;
  isInternalTime?: boolean | null;
  favoured?: boolean | null;
  disabled?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type favoriteIdleTimeMutation$variables = {
  input: UpdateIdleTimeInput;
};
export type favoriteIdleTimeMutation$data = {
  readonly updateIdleTime: {
    readonly idleTime: {
      readonly id: string;
      readonly favoured: boolean | null;
    } | null;
  } | null;
};
export type favoriteIdleTimeMutation = {
  variables: favoriteIdleTimeMutation$variables;
  response: favoriteIdleTimeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIdleTimePayload",
    "kind": "LinkedField",
    "name": "updateIdleTime",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdleTime",
        "kind": "LinkedField",
        "name": "idleTime",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "favoured",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "favoriteIdleTimeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "favoriteIdleTimeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e8fc9c45ef9b18ca77ccd8509ded8c6a",
    "id": null,
    "metadata": {},
    "name": "favoriteIdleTimeMutation",
    "operationKind": "mutation",
    "text": "mutation favoriteIdleTimeMutation(\n  $input: UpdateIdleTimeInput!\n) {\n  updateIdleTime(input: $input) {\n    idleTime {\n      id\n      favoured\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a75cc752b17ac22ab4d0e5a517d7f1b3";

export default node;
